import type { Permission } from "@entur-partner/permission-client-node";
import { hasPermissions } from "@entur-partner/util";

import { OPS_CAPABILITY_PREFIX, SUPPORT_CAPABILITIES } from "@/AccessPermissions.ts";

const STORAGE_KEY = "AutomatOps::supportPreview";

export function readStoredSupportPreview(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function storeSupportPreview(enabled: boolean) {
  try {
    if (enabled) {
      sessionStorage.setItem(STORAGE_KEY, "true");
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {}
}

export function applySupportPreview(permissions: Permission[]): Permission[] {
  return permissions.filter(
    (permission) =>
      !permission.operation.startsWith(OPS_CAPABILITY_PREFIX) || hasPermissions(SUPPORT_CAPABILITIES, permission)
  );
}
